import { gql } from '@apollo/client';

export const CREATE_MESSAGE = gql`
  mutation CreateMessage(
    $threadId: ID!
    $content: String
    $attachments: [AttachmentInputType!]
  ) {
    createMessage(
      input: {
        messageThreadId: $threadId
        content: $content
        attachments: $attachments
      }
    ) {
      message {
        id
        content
        sentAt
        deliveredAt
        readAt
        attachments {
          id
          url
          filename
          contentType
        }
        sender {
          id
          name
        }
      }
      errors
    }
  }
`;
